import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProgressTable from './EffectProgressTable/EffectProgressTable';
import {
  Description,
  DescriptionSegment,
  Header,
  ShowButton,
  TimestampsWrapper,
  Wrapper,
} from './EffectReportTemplate.styles';
import ReportTimestamps from './ReportTimestemps/ReportTimestamps';
import { convertTypeString } from '../../../../helpers/helpers';
import { TogglerKeys } from '../../../../hooks/useReport';
import { Analysis, IToggleState } from '../../../../services/reports';

interface EffectReportTemplateProps {
  data: Analysis;
}

const EffectReportTemplate: React.FC<EffectReportTemplateProps> = ({ data }) => {
  const slicedDescription = data.description.split('<br>');
  const [descriptionVisibility, setDescriptionVisibility] = useState<boolean>(false);
  const [togglersState, setTogglersState] = useState<IToggleState>({
    historical_result: false,
    variation_between_respondents: false,
    organization_mean: false,
    external_benchmark: false,
    team_manager: false,
  });

  const { t } = useTranslation();

  const handleWrapDescription = () => {
    setDescriptionVisibility(state => !state);
  };

  const handleToggleState = (name: TogglerKeys) => {
    setTogglersState(prevState => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  return (
    <>
      <Header>{t(`report.effect.topics.${convertTypeString(data.type)}`)}</Header>
      <Wrapper>
        <DescriptionSegment>
          <div>
            <Description
              dangerouslySetInnerHTML={{
                __html: descriptionVisibility ? data.description : slicedDescription[0],
              }}
            />
          </div>
          <TimestampsWrapper>
            {data.description.includes('<br>') ? (
              <ShowButton onClick={handleWrapDescription}>
                {descriptionVisibility
                  ? `${t('report.effect.buttons.showLess')} <<`
                  : `${t('report.effect.buttons.showMore')} >>`}
              </ShowButton>
            ) : (
              <div />
            )}
            <ReportTimestamps handleToggleState={handleToggleState} data={data} />
          </TimestampsWrapper>
        </DescriptionSegment>
        <ProgressTable data={data} togglersState={togglersState} />
      </Wrapper>
    </>
  );
};

export default EffectReportTemplate;
